import { z } from "zod";

const MAX_CHAT_MESSAGE_LENGTH = 5000;
const MAX_CHAT_FILE_COUNT = 10;

export const textMessageSchema = z.object({
	content: z
		.string()
		.max(MAX_CHAT_MESSAGE_LENGTH, {
			message: `Message cannot exceed ${MAX_CHAT_MESSAGE_LENGTH} characters`,
		}),
	files: z
		.array(z.instanceof(File))
		.max(MAX_CHAT_FILE_COUNT, { message: `You can attach up to ${MAX_CHAT_FILE_COUNT} files` }),
});

export type TextMessageSchema = z.infer<typeof textMessageSchema>;
export type TextMessageFormData = Omit<TextMessageSchema, "files"> & { files: File[] };
